export default {
  validate (val) {
    return val.indexOf(',') === -1
  }
}
